<script setup>
import { useListenConfigStore } from "@/hooks/useListenConfigStore";
import { computed, onMounted, onUnmounted, ref } from "vue";
import { imageConfig } from "@/views/listening/components/ThemeTag/imageConfig";

const listenStore = useListenConfigStore();

const visible = ref(false); //主题状态

const speed = computed(() => listenStore.playbackRate);

const theme = computed(() => listenStore.theme);

const imageMap = computed(() => imageConfig[theme.value]);

const changeSpeed = (val) => {
  listenStore.setPlaybackRate(val);
};
const speedRef = ref();

const handleClickOutside = (e) => {
  if (visible.value) {
    let isSelf = speedRef.value.contains(e.target);
    if (!isSelf && e.target.alt !== "speed") {
      visible.value = false;
    }
  }
}

onMounted(()=>{
  document.addEventListener("click", handleClickOutside);
})

onUnmounted(()=>{
  document.removeEventListener("click", handleClickOutside);
})

const speedImgList = [
  {
    speed: 0.6,
    name: "speed0_6",
  },
  {
    speed: 0.8,
    name: "speed0_8",
  },
  {
    speed: 1,
    name: "speed1",
  },
  {
    speed: 1.2,
    name: "speed1_2",
  },
  {
    speed: 1.5,
    name: "speed1_5",
  },
];
</script>

<template>
  <div :class="theme">
    <span v-for="(img, index) in speedImgList" :key="index">
      <img
        class="speed-img"
        v-if="speed == img.speed"
        :src="imageMap[img.name]"
        alt="speed"
        @click="visible = !visible"
      />
    </span>
    <div v-if="visible" class="speed-box" ref="speedRef">
      <img
        v-for="(img, index) in speedImgList"
        :key="index"
        :src="speed == img.speed ? imageConfig['speedActive'][img.name] : imageConfig['white'][img.name]"
        alt="speed"
        @click="changeSpeed(img.speed)"
      />
    </div>
  </div>
</template>

<style scoped lang="less">
.speed-img{
  width: 1.27rem;
}
.speed-box {
  width: 11.4rem;
  background-color: white;
  position: absolute;
  right:0;
  display: flex;
  justify-content: space-around;
  border-radius: 0.4rem;
  padding: 0.64rem;
  gap: 0.7rem;
  flex-direction: row;
  align-items: center;
  z-index: 3;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.10);
  img {
    width: 1.27rem;
    height: 1.27rem;
  }
}
</style>
